import Error from 'next/error'
import { LOCALES } from '../constants'
import { templates } from '../templates'
import * as Sentry from '@sentry/nextjs'
import { getErrorMessage } from '../db/getErrorMessage'
import { getMegaMenuAndFooter } from '../db/getMegaMenuAndFooter'

export const getServerSideProps = async (props) => {
  const { query, res, err, resolvedUrl } = props
  await Sentry.captureException(err)

  const statusCode = res.statusCode || err?.statusCode || 404

  res.statusCode = statusCode

  if (statusCode === 404) {
    const { slug = [] } = query
    const resolvedUrlSlug = resolvedUrl.split('/').filter(Boolean)

    const errorLocale = slug[0] || resolvedUrlSlug[0]
    const locale = (() => {
      if (LOCALES.has(errorLocale)) {
        return LOCALES.get(errorLocale)
      }

      return LOCALES.get('gb')
    })()
    const errorMessage = await getErrorMessage({ locale })
    const megaMenuAndFooter = await getMegaMenuAndFooter({ locale })

    return {
      props: {
        statusCode,
        pageProps: {
          errorMessage: errorMessage,
          megaMenu: megaMenuAndFooter.megamenu,
          footer: megaMenuAndFooter.footer,
          locale
        }
      }
    }
  }

  return {
    props: {
      statusCode
    }
  }
}

const ErrorPage = ({ statusCode, pageProps }) => {
  if (statusCode === 404) {
    return <templates.NotFound {...pageProps} />
  }

  return <Error {...{ statusCode }} />
}

export const config = { amp: false }

export default ErrorPage
